'use strict';

import angular from 'angular';
import Main from './collecte.controller';

export default angular.module('aperamApp.borne.collecte', [])
  .controller('CollecteController', Main)
  .name;


// WEBPACK FOOTER //
// ./client/app/borne/collecte/index.js